export default __webpack_public_path__ + "static/externalFilter-a9934bdb9e0f1430a70858b0f3628075.gif";